var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        {
          staticClass:
            "flex gap-2 items-center text-primary text-xl font-medium",
        },
        [
          _c("v-icon", { attrs: { color: "primary" } }, [
            _vm._v(" mdi-note-text-outline "),
          ]),
          _c("span", [_vm._v("ตั้งค่าออเดอร์")]),
        ],
        1
      ),
      _c(
        "v-card",
        { staticClass: "py-5 px-7 mt-6 rounded-lg", attrs: { flat: "" } },
        [
          _c("p", { staticClass: "text-xl font-medium mb-5" }, [
            _vm._v(" สถานะออเดอร์ "),
          ]),
          _c("order-toggle", {
            attrs: {
              text: _vm.$t("order.enableReadyToShipStage"),
              state: _vm.state.enableReadyToShipStage,
              description:
                "ทุกออเดอร์จะมีขั้นตอนยืนยันออเดอร์ขึ้นมาเพื่อให้ร้านค้ากดยืนยันออเดอร์ก่อนที่จะย้ายออเดอร์ไปอยู่ที่สถานะรอพิมพ์",
            },
            on: {
              input: function ($event) {
                return _vm.submit("enableReadyToShipStage")
              },
            },
            model: {
              value: _vm.setting.enableReadyToShipStage,
              callback: function ($$v) {
                _vm.$set(_vm.setting, "enableReadyToShipStage", $$v)
              },
              expression: "setting.enableReadyToShipStage",
            },
          }),
          _c("div", { staticClass: "my-7" }, [_c("hr")]),
          _c("order-toggle", {
            attrs: {
              text: _vm.$t("order.enableHolding"),
              state: _vm.state.enableHolding,
              description:
                "สามารถกดพักออเดอร์เพื่อจัดส่งภายหลัง หรือลูกค้าจะสามารถแจ้งโอนเงินได้หลายครั้ง",
            },
            on: {
              input: function ($event) {
                return _vm.submit("enableHolding")
              },
            },
            model: {
              value: _vm.setting.enableHolding,
              callback: function ($$v) {
                _vm.$set(_vm.setting, "enableHolding", $$v)
              },
              expression: "setting.enableHolding",
            },
          }),
          _c("div", { staticClass: "my-7" }, [_c("hr")]),
          _c("order-toggle", {
            attrs: {
              text: _vm.$t("order.changePrint"),
              description:
                "หลังจากการพิมพ์ที่อยู่แล้วมีการแก้ไขออเดอร์ ออเดอร์นั้นจะเปลี่ยนสถานะกลับมาอยู่ที่สถานะ “รอพิมพ์” เพื่อให้พิมพ์ใหม่อีกครั้ง",
              state: _vm.state.changePrint,
            },
            on: {
              input: function ($event) {
                return _vm.submit("changePrint")
              },
            },
            model: {
              value: _vm.setting.changePrint,
              callback: function ($$v) {
                _vm.$set(_vm.setting, "changePrint", $$v)
              },
              expression: "setting.changePrint",
            },
          }),
        ],
        1
      ),
      _c(
        "v-card",
        { staticClass: "py-5 px-7 mt-6 rounded-lg", attrs: { flat: "" } },
        [
          _c("p", { staticClass: "text-xl font-medium mb-5" }, [
            _vm._v(" การยกเลิกออเดอร์ "),
          ]),
          _c("order-toggle", {
            attrs: {
              text: _vm.$t("order.autoCancelMarketplaceOrder"),
              description:
                "เมื่อออเดอร์ Marketplace ถูกตีกลับ ระบบจะยกเลิกออเดอร์ให้อัตโมมัติ",
              state: _vm.state.autoCancelMarketplaceOrder,
            },
            on: {
              input: function ($event) {
                return _vm.submit("autoCancelMarketplaceOrder")
              },
            },
            model: {
              value: _vm.setting.autoCancelMarketplaceOrder,
              callback: function ($$v) {
                _vm.$set(_vm.setting, "autoCancelMarketplaceOrder", $$v)
              },
              expression: "setting.autoCancelMarketplaceOrder",
            },
          }),
          _c("div", { staticClass: "my-7" }, [_c("hr")]),
          _c("order-toggle", {
            attrs: {
              text: _vm.$t("order.autoCancelShipnityExpressOrder"),
              state: _vm.state.autoCancelShipnityExpressOrder,
              description:
                " เมื่อออเดอร์ที่ส่งผ่านระบบ Shipnity Express ถูกตีกลับ ระบบจะยกเลิกออเดอร์ให้อัตโมมัติ",
            },
            on: {
              input: function ($event) {
                return _vm.submit("autoCancelShipnityExpressOrder")
              },
            },
            model: {
              value: _vm.setting.autoCancelShipnityExpressOrder,
              callback: function ($$v) {
                _vm.$set(_vm.setting, "autoCancelShipnityExpressOrder", $$v)
              },
              expression: "setting.autoCancelShipnityExpressOrder",
            },
          }),
        ],
        1
      ),
      _c(
        "v-card",
        { staticClass: "py-5 px-7 mt-6 rounded-lg", attrs: { flat: "" } },
        [
          _c("p", { staticClass: "text-xl font-medium mb-5" }, [
            _vm._v(" การแจ้งโอนเงิน "),
          ]),
          _c("order-toggle", {
            attrs: {
              text: _vm.$t("order.editProductAfterPay"),
              state: _vm.state.editProductAfterPay,
              description:
                " หากลูกค้าทำการแจ้งโอนเงินมา แล้วต้องการแก้ไขสินค้าในออเดอร์นั้นๆ ทางร้านค้าจะสามารถทำการแก้ไขสินค้าในออเดอร์นั้นได้",
            },
            on: {
              input: function ($event) {
                return _vm.submit("editProductAfterPay")
              },
            },
            model: {
              value: _vm.setting.editProductAfterPay,
              callback: function ($$v) {
                _vm.$set(_vm.setting, "editProductAfterPay", $$v)
              },
              expression: "setting.editProductAfterPay",
            },
          }),
          _c("div", { staticClass: "my-7" }, [_c("hr")]),
          _c("order-toggle", {
            attrs: {
              text: _vm.$t("order.pendingAllOrders"),
              state: _vm.state.pendingAllOrders,
              description:
                " เมื่อแจ้งโอนเงินเรียบร้อยแล้วร้านค้าต้องกดยืนยันการแจ้งโอนเงินแต่ละออเดอร์อีกครั้งเพื่อยืนยันการชำระเงิน",
            },
            on: {
              input: function ($event) {
                return _vm.submit("pendingAllOrders")
              },
            },
            model: {
              value: _vm.setting.pendingAllOrders,
              callback: function ($$v) {
                _vm.$set(_vm.setting, "pendingAllOrders", $$v)
              },
              expression: "setting.pendingAllOrders",
            },
          }),
        ],
        1
      ),
      _c(
        "v-card",
        { staticClass: "py-5 px-7 mt-6 rounded-lg", attrs: { flat: "" } },
        [
          _c("p", { staticClass: "text-xl font-medium mb-5" }, [
            _vm._v(" Facebook Live "),
          ]),
          _c("order-toggle", {
            attrs: {
              text: _vm.$t("order.liveOrderAutoMerge"),
              state: _vm.state.liveOrderAutoMerge,
              description:
                "กรณีเป็นออเดอร์ลูกค้าคนเดียวกันจากช่องทาง Facebook Live คนละ Live\n      ระบบจะรวมออเดอร์ของลูกค้าเป็นออเดอร์เดียวกันให้อัตโนมัติ หากออเดอร์นั้นยังไม่ชำระเงิน",
            },
            on: {
              input: function ($event) {
                return _vm.submit("liveOrderAutoMerge")
              },
            },
            model: {
              value: _vm.setting.liveOrderAutoMerge,
              callback: function ($$v) {
                _vm.$set(_vm.setting, "liveOrderAutoMerge", $$v)
              },
              expression: "setting.liveOrderAutoMerge",
            },
          }),
        ],
        1
      ),
      _c(
        "v-card",
        { staticClass: "py-5 px-7 mt-6 rounded-lg", attrs: { flat: "" } },
        [
          _c("p", { staticClass: "text-xl font-medium mb-5" }, [
            _vm._v(" ระบบขายหน้าร้าน (POS) "),
          ]),
          _c("order-toggle", {
            attrs: {
              text: _vm.$t("order.posAutoRedirect"),
              state: _vm.state.posAutoRedirect,
              description:
                "เมื่อบันทึกออเดอร์ขายหน้าร้าน (POS) แล้วจะไปที่หน้าพิมพ์ใบเสร็จทันที",
            },
            on: {
              input: function ($event) {
                return _vm.submit("posAutoRedirect")
              },
            },
            model: {
              value: _vm.setting.posAutoRedirect,
              callback: function ($$v) {
                _vm.$set(_vm.setting, "posAutoRedirect", $$v)
              },
              expression: "setting.posAutoRedirect",
            },
          }),
        ],
        1
      ),
      _c(
        "v-card",
        {
          staticClass:
            "py-5 px-7 mt-6 rounded-lg flex flex-col sm:flex-row sm:items-center gap-2 justify-between",
          attrs: { flat: "" },
        },
        [
          _c("span", { staticClass: "text-xl font-medium" }, [
            _vm._v("รูปแบบเลขกำกับรายการ"),
          ]),
          _c("order-selection", {
            attrs: {
              state: _vm.state.invoiceNumberOption,
              items: _vm.invoiceNumberEnum,
            },
            on: {
              input: function ($event) {
                return _vm.submit("invoiceNumberOption")
              },
            },
            model: {
              value: _vm.setting.invoiceNumberOption,
              callback: function ($$v) {
                _vm.$set(_vm.setting, "invoiceNumberOption", $$v)
              },
              expression: "setting.invoiceNumberOption",
            },
          }),
        ],
        1
      ),
      _c(
        "v-card",
        { staticClass: "py-5 px-7 mt-6 rounded-lg", attrs: { flat: "" } },
        [
          _c(
            "v-form",
            {
              ref: "form",
              attrs: { readonly: _vm.loading, "lazy-validation": "" },
              on: {
                submit: function ($event) {
                  $event.preventDefault()
                  return _vm.submit("preorderLimit")
                },
              },
              model: {
                value: _vm.valid,
                callback: function ($$v) {
                  _vm.valid = $$v
                },
                expression: "valid",
              },
            },
            [
              _c(
                "div",
                { staticClass: "flex items-center sm:justify-between" },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "flex items-center gap-2 text-base sm:text-xl font-medium",
                    },
                    [
                      _vm._v(" " + _vm._s(_vm.$t("order.preorderLimit")) + " "),
                      _vm.edit
                        ? _c("v-text-field", {
                            staticStyle: { "max-width": "200px" },
                            attrs: {
                              dense: "",
                              outlined: "",
                              "hide-details": "",
                            },
                            model: {
                              value: _vm.setting.preorderLimit,
                              callback: function ($$v) {
                                _vm.$set(_vm.setting, "preorderLimit", $$v)
                              },
                              expression: "setting.preorderLimit",
                            },
                          })
                        : _c("span", { staticClass: "text-primary" }, [
                            _vm._v(
                              " " + _vm._s(_vm.setting.preorderLimit) + " "
                            ),
                          ]),
                      _vm._v(" " + _vm._s(_vm.$t("order.days")) + " "),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    [
                      _vm.edit
                        ? _c("save-change-button", {
                            staticClass: "mr-1",
                            attrs: {
                              state: _vm.state.preorderLimit,
                              disabled: !_vm.valid,
                              label: _vm.$t("order.btn.save"),
                            },
                            on: {
                              click: function ($event) {
                                return _vm.submit("preorderLimit")
                              },
                            },
                          })
                        : _c(
                            "v-btn",
                            {
                              attrs: {
                                color: "primary",
                                rounded: "",
                                depressed: "",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.openEditOrderAge()
                                },
                              },
                            },
                            [
                              _c("v-icon", { attrs: { icon: "" } }, [
                                _vm._v(" mdi-square-edit-outline "),
                              ]),
                              _c("span", [
                                _vm._v(
                                  " " + _vm._s(_vm.$t("order.btn.edit")) + " "
                                ),
                              ]),
                            ],
                            1
                          ),
                    ],
                    1
                  ),
                ]
              ),
            ]
          ),
          _c("span", { staticClass: "text-order-closed text-sm font-normal" }, [
            _vm._v("ระยะเวลาออเดอร์สำหรับการแจ้งโอนเงิน"),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }